import React from "react";
import { Tooltip } from "devextreme-react/tooltip";

type Props = {
  target: string;
  message: string;
  position?: "bottom" | "left" | "right" | "top";
  showEvent?: string;
  hideEvent?: string;
};
const TooltipComponent = ({
  target,
  message,
  position = "top",
  showEvent = "mouseenter",
  hideEvent = "mouseleave",
}: Props) => {
  return (
    <Tooltip target={target} position={position} showEvent={showEvent} hideEvent={hideEvent}>
      <div>{message}</div>
    </Tooltip>
  );
};
export default TooltipComponent;
